import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxPointsIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.5776 2.65918H8.44078C5.24878 2.65918 2.65198 5.25598 2.65198 8.44798V15.5848C2.65198 18.7768 5.24878 21.3736 8.44078 21.3736H15.5776C18.7696 21.3736 21.3664 18.7768 21.3664 15.5848V8.44798C21.3664 5.25598 18.7696 2.65918 15.5776 2.65918ZM20.4752 15.5848C20.4752 18.2856 18.2776 20.4824 15.5776 20.4824H8.44078C5.73998 20.4824 3.54318 18.2848 3.54318 15.5848V8.44798C3.54318 5.74718 5.74078 3.55038 8.44078 3.55038H15.5776C18.2784 3.55038 20.4752 5.74798 20.4752 8.44798V15.5848Z"
            fill="#222"
          />
          <path
            d="M17.228 9.41998H14.0216L13.0408 6.40798C12.8888 5.93518 12.4664 5.62958 11.9648 5.62958C11.4632 5.62958 11.0408 5.93518 10.8888 6.40798L9.90718 9.43198H6.70158C6.19358 9.43198 5.79678 9.71278 5.64078 10.1824C5.50958 10.5792 5.57998 11.1296 6.03198 11.4672L8.62878 13.3424L7.64158 16.3416C7.44958 16.8888 7.71038 17.3784 8.05518 17.6208C8.23198 17.7456 8.46798 17.8288 8.71758 17.8288C8.93518 17.8288 9.16398 17.7656 9.37438 17.6112L11.9664 15.7408L14.5544 17.5984C15.0392 17.9544 15.5536 17.8352 15.8736 17.6056C16.2792 17.3144 16.444 16.8208 16.2944 16.3504L15.3008 13.3304L17.8824 11.4672C18.304 11.1688 18.464 10.7048 18.312 10.2272C18.184 9.82558 17.8 9.42078 17.2288 9.42078L17.228 9.41998ZM17.3744 10.7536L14.2688 12.9952L15.4592 16.612C15.4936 16.72 15.4568 16.8272 15.3648 16.8936C15.2728 16.9592 15.16 16.9584 15.0688 16.8912L11.9648 14.6624L8.85758 16.9048C8.81438 16.9368 8.76318 16.9536 8.70958 16.9536C8.65358 16.9536 8.59918 16.9352 8.55198 16.9C8.46318 16.8336 8.43118 16.7288 8.46798 16.6264L9.65918 13.0072L6.55518 10.7672C6.46238 10.6984 6.42718 10.5872 6.46318 10.4776C6.49838 10.372 6.58878 10.3056 6.69998 10.3056H10.5416L11.72 6.67438C11.7536 6.56878 11.8472 6.50318 11.9632 6.50318C12.08 6.50318 12.1736 6.56878 12.2072 6.67598L13.3848 10.2928H17.2264C17.3384 10.2928 17.436 10.3648 17.4696 10.4712C17.5032 10.5784 17.4664 10.6864 17.3728 10.752L17.3744 10.7536Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
